import {
  API_ENDPOINT,
  type ClientApiV1NotesMeQueryString,
  useClientApiV1NotesMeQuery,
} from '../../resources/@types/uccSchema';
import { generateQueryKeyUrl } from '../utils/generateQueryKeyUrl';

function useNoteMeQuery(
  params: ClientApiV1NotesMeQueryString,
  options?: Parameters<typeof useClientApiV1NotesMeQuery>[0]['options'],
) {
  return useClientApiV1NotesMeQuery({
    ...generateQueryKeyUrl(
      {
        url: API_ENDPOINT.CLIENT_V1_NOTES_ME,
        queryParams: params,
      },
      {
        /**
         * 검색어에 , 가 들어가는 경우 , 를 기준으로 key: value 쌍이 여러벌 생김
         * 따라서 해당 옵션 추가해 상기 이슈 방지
         */
        arrayFormat: 'separator',
      },
    ),
    options,
  });
}

export default useNoteMeQuery;
